import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faLinkedin, faGithub, faStackOverflow, faFacebook,/* faMedium, faDev,*/ faQuora } from "@fortawesome/free-brands-svg-icons";
import * as socialStyle from '../components/componentStyles/socialfollow.module.scss'
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
export default function SocialFollow() {
  return (
        <div className={socialStyle.socialContainer}>
                <a rel="noopener noreferrer" href="https://www.linkedin.com/in/absjabed/" target="_blank"
                className={socialStyle.linkedIn+ ' ' +socialStyle.social}>
                <FontAwesomeIcon icon={faLinkedin} size="lg" />
                </a>

                <a rel="noopener noreferrer" href="https://github.com/absjabed/" target="_blank"
                className={socialStyle.github+ ' ' +socialStyle.social}>
                <FontAwesomeIcon icon={faGithub} size="lg" />
                </a>

                <a rel="noopener noreferrer" href="https://stackoverflow.com/users/5277438/mohammad-abs-jabed" target="_blank"
                className={socialStyle.stackoverflow+ ' ' +socialStyle.social}>
                <FontAwesomeIcon icon={faStackOverflow} size="lg" />
                </a>
{/* 
                <a rel="noopener noreferrer" href="https://medium.com/@absjabed" target="_blank"
                className={socialStyle.medium+ ' ' +socialStyle.social}>
                <FontAwesomeIcon icon={faMedium} size="lg" />
                </a> */}

                <a rel="noopener noreferrer" href="https://twitter.com/absjabed" target="_blank" 
                className={socialStyle.twitter+ ' ' +socialStyle.social}>
                <FontAwesomeIcon icon={faTwitter} size="lg" />
                </a>

                <a rel="noopener noreferrer"  href = "mailto:debajsba@gmail.com?subject = Feedback&body = Message" target="_blank" 
                className={socialStyle.mail+ ' ' +socialStyle.social}>
                <FontAwesomeIcon icon={faEnvelope} size="lg" />
                </a>

                <a rel="noopener noreferrer" href="https://www.fb.com/absjbd/" target="_blank" 
                className={socialStyle.facebook+ ' ' +socialStyle.social}>
                <FontAwesomeIcon icon={faFacebook} size="lg" />
                </a>

                {/* <a rel="noopener noreferrer"  href = "https://dev.to/absjabed" target="_blank" 
                className={socialStyle.dev+ ' ' +socialStyle.social}>
                <FontAwesomeIcon icon={faDev} size="lg" />
                </a> */}

                <a rel="noopener noreferrer" href="https://www.quora.com/profile/Mohammad-Abs-Jabed" target="_blank" 
                className={socialStyle.quora+ ' ' +socialStyle.social}>
                <FontAwesomeIcon icon={faQuora} size="lg" />
                </a>
        </div>
  );
}
